import { Icon } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import React from "react";
// import Button from "../Button";

function HeaderText({ text, style, icone, aux, aux2 }) {
  const theme = useTheme();

  const defaultStyle = {
    borderLeft: "solid",
    borderLeftColor: theme.palette.primary.main,
    borderWidth: "5px",
    paddingLeft: "2%",
    marginBottom: "25px",
    display: "flex",
    justifyContent: "flex-start",
    alignContent: "center",
    alignItems: "center",
  };

  return (
    <div className="header-text-container" style={{ ...defaultStyle, style }}>
      <p
        className="h3"
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          width: "100%",
        }}
      >
        {text}

        {icone && <Icon> {icone} </Icon>}

        {aux}

        {aux2}
      </p>
    </div>
  );
}

HeaderText.prototype = {
  text: PropTypes.string.isRequired,
  aux: PropTypes.string,
  aux2: PropTypes.string,
  title: PropTypes.string,
  icone: PropTypes.any,
  style: PropTypes.object,
};

export default HeaderText;
